import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// TODO: wire to backend audit log when available
const ACTIVITY_ROWS = [
  { label: 'Sophie last active',    value: '2h ago' },
  { label: 'Rider updated',         value: '8 Apr'  },
  { label: 'Run of show confirmed', value: '10 Apr' },
  { label: 'Guest list updated',    value: '15 Apr' },
];

/* ─── Activity (collapsible, open by default)
   Visual shell matches Agreement exactly: same panel bg, same border,
   same mono header at fontSize 18, same chevron rotation. ─── */

export default function Activity() {
  const [open, setOpen] = useState(true);

  return (
    <div
      data-testid="activity-card"
      className="mb-6 overflow-hidden"
      style={{ background: '#171411', borderRadius: 16, border: '1px solid rgba(212, 169, 90, 0.12)' }}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4"
        type="button"
        data-testid="activity-toggle"
      >
        <div className="flex flex-col items-start">
          <h2 style={{ fontFamily: 'var(--s8-font-mono)', fontWeight: 500, fontSize: 18, letterSpacing: '0.04em', color: '#F0EBE0' }}>
            ACTIVITY
          </h2>
        </div>
        <ChevronDown
          size={18}
          color="#888"
          className="shrink-0"
          style={{ transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </button>
      {open && (
        <div className="px-5 py-4 space-y-3" style={{ background: '#1e1b16', borderTop: '1px solid #2a2620' }}>
          {ACTIVITY_ROWS.map((row) => (
            <div key={row.label} className="flex items-center justify-between" data-testid={`activity-row-${row.label.toLowerCase().replace(/\s+/g, '-')}`}>
              <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: '#888' }}>
                {row.label}
              </span>
              <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: '#F0EBE0' }}>
                {row.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
